import { getFirstElementOf, dispatchEvent } from '../common/elements-helper';

const toString = (value) => {
  if (value) {
    return value.toString();
  }
  return '';
};

/**
 * Ensure that the expression has only numbers
 * @param {number|string} value - Expression to be converted as only numbers
 * @return {Function} Formatter function that return the month represented in
 * a two digit string
 */
const toNumber = (value) => {
  const number = toString(value).replace(/^0|\D+/g, '') || '';
  return () => number;
};

const onlyNumbersDirective = {
  update: (el, binding) => {
    if (binding.value !== null) {
      const $el = getFirstElementOf(el, 'input');
      const format = toNumber(binding.value);
      $el.value = format();
      dispatchEvent($el, 'input');
    }
  },
};

export default onlyNumbersDirective;
